import { render, staticRenderFns } from "./selectBusBox.vue?vue&type=template&id=1ab1b1f4&scoped=true&"
import script from "./selectBusBox.vue?vue&type=script&lang=js&"
export * from "./selectBusBox.vue?vue&type=script&lang=js&"
import style0 from "./selectBusBox.vue?vue&type=style&index=0&id=1ab1b1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab1b1f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
